import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import downloadForm from '../assests/img/ADMISSION-FORM.pdf';
import { Helmet } from 'react-helmet-async';


function Admission() {
  return (
    <div >
      <Helmet>
        <title>Admission | State Board of Secondary Education, Delhi</title>
        <meta
          name="description"
          content="Learn more about the Admission process at the State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy."
        />
        <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}
      <div className='container'>
        <div className='about-banner'>
          <img src={aboutBanner} alt="" />
          <h1 className='page-title'>Admission</h1>
        </div>
      </div>

      <div className='container main-contant'>
        <div className='inner-page-container'>
          <div className="content-secion">
            <h3 className="text"><em><span style={{ color: "#ff0000" }}>Admission Information:</span></em></h3>
            <p className="text">Student can obtained prescribed Admission Form along with Prospectus from Authorized Centre or filling up online admission form.</p>
            <h3 className="heading3" style={{ textAlign: "center" }}><span style={{ color: "#00ff00" }}><strong>ONLINE ADMISSION FORM</strong></span></h3>
          </div>

          <div className='download-form'>
            <a class="btn btn-success" href={downloadForm}>Click Here To download The Admission Form</a>
          </div>

          <div className="content-secion">
            <p className="text">The filled Admission form/Online Admission form has to be submitted at Authorized Centre along with the following documents:</p>
            <ol className="text">
              <li>2 (Two) sets of photo copies (Xerox) of all Certificate, Mark Sheet, Admit Card of last Examination passed.</li>
              <li>4 (Four) Copies of recent color passport size photographs.</li>
              <li>Take a print out of Online Admission form and Acknowledgement Slip (for Online Admission Candidates)</li>
            </ol>
            <p className="text">Payment Option:</p>
            <ol>
              <li className="text">Cash Payment at Authorized Centre</li>
              <li className="text">By Demand Draft (DD) in favour of “STATE BOARD OF SECONDARY EDUCATION, DELHI” payable at Delhi by post or Regional Office.</li>
            </ol>
            <p className="headingFee">Fee Details: (Excluding Study Centre fees and Study Material fees)</p>

            <table className="table" style={{ border: "2px solid #affaa8" }} border="0" width="90%" cellspacing="3" cellpadding="3">
              <tbody>
                <tr>
                  <td>
                    <p className="text">Payment Option:</p>
                    <ol>
                      <li className="text">Cash Payment at Authorized Centre</li>
                      <li className="text">By Demand Draft (DD) in favour of “STATE BOARD OF SECONDARY EDUCATION, DELHI” payable at Delhi by post or Regional Office.</li>
                    </ol>
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="headingFee">Fee Details: (Excluding Study Centre fees and Study Material fees)</p>
            <table className="table" style={{ border: "2px solid #affaa8" }} border="0" width="90%" cellspacing="3" cellpadding="3">
              <tbody>
                <tr>
                  <td><strong> Admission Fee </strong>1990/-</td>
                  <td><strong>Registration Fee</strong> 1000/-</td>
                </tr>
                <tr>
                  <td><strong>Programme Fees For 5 Subject </strong>7000/-</td>
                  <td><strong>Cost of information Brochure (Prospectus)</strong><p></p>
                    <p><strong> along with the Application Form&nbsp;</strong>350/</p></td>
                </tr>
                <tr>
                  <td><b>Examination Fee (Per Subject)</b> 700/-</td>
                  <td><strong>Furniture</strong> 250/-</td>
                </tr>
                <tr>
                  <td><strong>Electricity</strong> 500/-</td>
                  <td><strong> Games and Sports </strong>250/-</td>
                </tr>
                <tr>
                  <td><strong>Part admission fee (Per Subject)</strong>2500/-</td>
                  <td><strong>Festival</strong> 350/-</td>
                </tr>
                <tr>
                  <td><strong> Library Fee</strong> 150/-</td>
                  <td><strong> Identity Card </strong>100/-</td>
                </tr>
                <tr>
                  <td><strong> Others</strong> 100/- </td>
                  <td style={{ fontSize: "14px", color: "maroon" }}></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Admission;
